/**
 * Centralized permission keys for RBAC (Phase IW3.12.A).
 * Use with useMenuPermission(MENU_PATHS.INCIDENTS) etc.
 */

export const MENU_PATHS = {
  /** Cấu hình widget Tổng quan (ẩn menu; RBAC qua path) */
  OVERVIEW_WIDGET: '/overview/widget',
  /** Admin: template dashboard (menu ẩn + entry sidebar có điều kiện) */
  OVERVIEW_TEMPLATES: '/config/overview-templates',
  INCIDENTS: '/incidents',
  WORK_REPORTS: '/work-reports',
  PROJECTS_LIST: '/projects/list',
  PROJECTS_ASSIGNMENT: '/projects/assignment',
  PROJECTS_DUTY_SCHEDULES: '/projects/duty-schedules',
  PERMISSIONS_ACCOUNTS: '/permissions/accounts',
  PERMISSIONS_ROLES: '/permissions/roles',
  /** IW3.14.3.1: Quyền sửa/xoá dữ liệu người khác (delegation). Nếu backend chưa có menu_item thì fallback PERMISSIONS_ROLES. */
  PERMISSIONS_DELEGATIONS: '/permissions/delegations',
  INCIDENTS_CONFIG: '/incidents-config',
  /** Sizing Admin Config + future User Execution (menu path; show_in_menu remains false until S7) */
  OPTIMIZATION_SIZING: '/optimization/sizing',
  OPTIMIZATION: '/optimization',
} as const;

export type MenuPathKey = keyof typeof MENU_PATHS;

/**
 * IW3.15.A.2: Allowlist paths áp dụng delegation (EDIT_OTHERS/DELETE_OTHERS).
 * Loại trừ Danh bạ người dùng (/users-directory), Chi nhánh (/branches) và các menu không có owner.
 */
export const DELEGATION_APPLICABLE_MENU_PATHS: readonly string[] = [
  MENU_PATHS.INCIDENTS,
  MENU_PATHS.WORK_REPORTS,
  MENU_PATHS.PROJECTS_LIST,
  MENU_PATHS.PROJECTS_ASSIGNMENT,
  MENU_PATHS.PROJECTS_DUTY_SCHEDULES,
  MENU_PATHS.PERMISSIONS_ACCOUNTS,
  MENU_PATHS.PERMISSIONS_ROLES,
  MENU_PATHS.PERMISSIONS_DELEGATIONS,
  MENU_PATHS.INCIDENTS_CONFIG,
];

export const ACTIONS = ['view', 'create', 'update', 'delete'] as const;
export type ActionKey = (typeof ACTIONS)[number];
